<app-dynamic-form
  [clientId]="clientId"
  [patientId]="patientId"
  [templateId]="'new_patient_registration'">
</app-dynamic-form>
